import React from "react";

const DoctorClaimPanel: React.FC = () => {
  return (
    <div className="bg-white">
      <div className="container doctor-claim-panel py-xxl">
        <div className="row">
          <div className="col lg:col-1/2 p-none">
            <h4 className="heading--m mt-xl">Is this your medical practice?</h4>
            <p className="text-sm pt-xs">
              It's easy to set up your profile! Once you do, you can receive
              appointment requests from patients nearby who are interested in
              medical marijuana.
            </p>
            <a
              className="button button--primary my-xxl"
              href="https://success.leafly.com/claim-your-practice"
            >
              claim your practice
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorClaimPanel;
